import { AbstractWidget } from "../utils/AbstractWidget"
import ServicePartnerFinder from "../components/servicePartnerFinder/ServicePartnerFinder";

export default class ServicePartnerWidget extends AbstractWidget {
  get UIComponent() {
    return ServicePartnerFinder;
  }
}
